var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 40,
    viewBox: "0 0 65 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.13292 0H61.8701C63.0489 0 64.0031 0.954204 64.0031 2.13293V37.8671C64.0031 39.0458 63.0489 40 61.8701 40H2.13292C0.9542 40 0 39.0458 0 37.8671V2.13293C0 0.954204 0.9542 0 2.13292 0Z",
    fill: "#3957A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4529 26.0083H26.325L28.2793 13.9966H31.4072L29.4529 26.0083Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6969 13.9966L20.717 22.2578L20.3649 20.477L19.3137 15.0784C19.3137 15.0784 19.1862 13.9966 17.8288 13.9966H12.8997L12.8435 14.2007C12.8435 14.2007 14.3488 14.512 16.1143 15.5733L18.829 26.0083H22.0845L27.0596 14.0017H23.6918L23.6969 13.9966Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2869 26.0081H51.1546L48.6543 14.0015H46.1387C44.9753 14.0015 44.6946 14.8944 44.6946 14.8944L40.0308 26.0081H43.2914L43.9445 24.2222H47.9195L48.2869 26.0081ZM44.8477 21.7627L46.4908 17.2672L47.4143 21.7627H44.8477Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2807 16.8847L40.7246 14.3078C40.7246 14.3078 39.3469 13.7822 37.913 13.7822C36.3618 13.7822 32.6777 14.4609 32.6777 17.7572C32.6777 20.8597 37.0048 20.9005 37.0048 22.5282C37.0048 24.156 33.1267 23.8651 31.8459 22.8395L31.3816 25.5337C31.3816 25.5337 32.7797 26.2124 34.9126 26.2124C37.0456 26.2124 40.2654 25.1051 40.2654 22.0996C40.2654 19.0941 35.9026 18.6859 35.9026 17.3286C35.9026 15.9713 38.9489 16.1448 40.2858 16.8847H40.2807Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3649 20.4824L19.3137 15.0837C19.3137 15.0837 19.1862 14.002 17.8288 14.002H12.8997L12.8435 14.2061C12.8435 14.2061 15.2112 14.6959 17.4819 16.5329C19.6556 18.2933 20.3598 20.4824 20.3598 20.4824H20.3649Z",
    fill: "#F9A533"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.edae9e16717ee3f5e1057c87d8f870b2.svg";
export { ForwardRef as ReactComponent };